import { Box, Chip, FormControl, FormLabel, Grid } from '@mui/joy';
import type { OpportunityRep } from '../../types';
import { userDisplayName } from '../../utils/userDisplay';

/**
 * Read-only list of a job's additional sales reps, carried over from the
 * opportunity at conversion. Commissions stay with the primary rep, so this
 * is display-only. Renders nothing when the job has no additional reps.
 */
export function JobAdditionalReps({ reps }: { reps?: OpportunityRep[] }) {
  if (!reps?.length) return null;
  return (
    <Grid xs={12} sm={6}>
      <FormControl>
        <FormLabel sx={{ fontWeight: 500 }}>Additional Reps</FormLabel>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mt: 0.5 }}>
          {reps.map((rep) => (
            <Chip key={rep.id} size="sm" variant="soft" color="neutral">
              {userDisplayName(rep)}
              {rep.is_active === false ? ' (inactive)' : ''}
            </Chip>
          ))}
        </Box>
      </FormControl>
    </Grid>
  );
}
